module.exports = __webpack_public_path__ + "img/ic_google_white@2x.e7e5a1d.png";